import { Button, Dropdown } from 'antd'
import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
export const DropDown = styled(Dropdown)``
export const DropBtn = styled(Button)`
  .ant-btn {
    background: ${COLORS.PRIMARY_GREY_T_98} !important;
  }
`
export const PaddedDiv = styled(Flex)`
  padding: 20px 25px;
  gap: 25px;
`
export const SectionWrapper = styled(Flex)`
  width: 100%;
  overflow: scroll;
  background: ${COLORS.WHITE};
  &::-webkit-scrollbar {
    display: none;
  }
`
export const TopHeader = styled(Flex)`
  position: relative;
  width: 100%;
  font-size: ${FONT.F_3XL};
`
export const RoleNameFlex = styled(Flex)``
export const TopEndFlex = styled(Flex)`
  gap: ${props => (props?.gap ? props?.gap : '0')};
`
export const LeftSection = styled(Flex)`
  gap: 20px;
`
export const SectionName = styled(Flex)`
  gap: 10px;
`
export const RoleNameDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XL};
  color: ${COLORS.GREY_T_20};
  margin: 10px 0 10px;
`
export const InterviewDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_30};
  margin: 10 10px 0 0;
`
export const ClockDiv = styled.div`
  border: 1px solid ${COLORS.GREY_T_90};
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 10px;
  cursor: pointer;
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`
export const ButtonDiv = styled.div`
  padding: 0 20px 0 0;
  border-right: 1px solid ${COLORS.GREY_T_90};
`
export const ThreeDotsDiv = styled.div`
  cursor: pointer;

  .ant-btn {
    background: ${COLORS.PRIMARY_GREY_T_98} !important;
    border-radius: 10px !important;
    border: 1px solid ${COLORS.GREY_T_90} !important;
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  }
`
export const SectinFlex = styled(Flex)``
export const DriveDetailDiv = styled.div`
  width: 68%;
  margin-right: 70px;
`
export const DrivInfoDiv = styled.div`
  width: 40%;
`
export const AntdSpan = styled.span`
  margin-right: 0.5px;
`
export const SettingIconDiv = styled.div`
  height: 34px;
  width: 34px;
  background: #3249d7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`
export const SettingIconClick = styled.div`
  margin-top: 2px;
  cursor: pointer;
`
export const ClockButtonDiv = styled.div`
  align-items: center;
  display: flex;
  gap: 15px;
  justify-content: center;

  padding-left: 15px;
`
export const SettingButtonDiv = styled.div`
  margin-right: 15px;
`
export const InterviewDivAlign = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
export const InterviewDivTopAlign = styled.div`
  display: flex;
  gap: 15px;
  margin-top: -30px;
`
export const InterviewDivTopExAlign = styled.div`
  display: flex;
  gap: 15px;
`
